import Cookie from 'corp-front-vue-commons/src/utils/Cookie'
import { SESSION_USER } from 'utils/constants'

const user = JSON.parse(Cookie.get(SESSION_USER))
const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null }

const actions = {
  loginRequest ({ commit }, payload) {
    commit('loginRequest', payload)
  },

  loginSuccess ({ commit }, payload) {
    commit('loginSuccess', payload)
  },

  loginFailure ({ commit }, payload) {
    commit('loginFailure', payload)
  },

  logout ({ commit }) {
    commit('logout')
  }
}

const mutations = {
  loginRequest (state, user) {
    state.status = {
      loggingIn: true
    }
    state.user = user
  },

  loginSuccess (state, user) {
    state.status = {
      loggedIn: true
    }
    state.user = user
  },

  loginFailure (state) {
    state.status = {}
    state.user = null
  },

  logout (state) {
    state.status = {}
    state.user = null
  },

  registerRequest (state, user) {
    state.status = {
      registering: true
    }
  },

  registerSuccess (state, user) {
    state.status = {}
  },

  registerFailure (state, error) {
    state.status = {}
  }
}

const Session = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default Session
